export default __webpack_public_path__ + "6e1700c564a82ae9aecb155d969b4eef.png";